import { useApplicationProductQuery, useCreateApplicationProductMutation, useUpdateApplicationProductMutation, useDeleteApplicationProductMutation } from './useApplicationProductsQuery';
import { ApplicationProduct } from '../types';

export const useApplicationProduct = (applicationId: string, applicationProductId?: string) => {

    if (!applicationId) {
        throw new Error('applicationId is required parameter');
    }

    const { data: record, isLoading: loading, refetch: fetchRecord } = useApplicationProductQuery(applicationProductId || '');
    const createApplicationProductMutation = useCreateApplicationProductMutation();
    const updateApplicationProductMutation = useUpdateApplicationProductMutation();
    const deleteApplicationProductMutation = useDeleteApplicationProductMutation();

    const createRecord = async (values: ApplicationProduct) => {
        values.applicationId = applicationId;
        return await createApplicationProductMutation.mutateAsync(values);
    };

    const updateRecord = async (values: ApplicationProduct) => {
        if (typeof applicationProductId === 'undefined') {
            throw new Error('applicationProductId is required parameter');
        }
        return await updateApplicationProductMutation.mutateAsync({ id: applicationProductId, record: values });
    };

    const deleteRecord = async () => {
        if (typeof applicationProductId === 'undefined') {
            throw new Error('applicationProductId is required parameter');
        }
        return await deleteApplicationProductMutation.mutateAsync(applicationProductId);
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
